import React from 'react';

const context = React.createContext(false);
context.displayName = 'RestrictedContext';

export default context;
